module.exports = __webpack_public_path__ + "img/gzpc.c115104f.svg";